import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { Company } from './company';
import { CompanyVendor } from './company-vendor';
import { SignedDocumentFile } from './signed-document-file';
import { Vendor } from './vendor';

export class SignedDocument extends BaseModel {
  static SignedDocumentProperties: (
    | {
        property: keyof SignedDocument;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof SignedDocument;
        type: 'alias';
      }
    | {
        property: keyof SignedDocument;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'name', type: 'column', dataType: 'string' },
    { property: 'signingUrl', type: 'column', dataType: 'string' },
    { property: 'description', type: 'column', dataType: 'string' },
    { property: 'documentId', type: 'column', dataType: 'string' },
    { property: 'widgetId', type: 'column', dataType: 'string' },
    { property: 'widgetUrl', type: 'column', dataType: 'string' },
    { property: 'widgetJS', type: 'column', dataType: 'string' },
    { property: 'service', type: 'column', dataType: 'string' },
    { property: 'fileName', type: 'column', dataType: 'string' },
    { property: 'documentType', type: 'column', dataType: 'string' },
    { property: 'signedDate', type: 'column', dataType: 'date' },
    { property: 'isArchived', type: 'column', dataType: 'boolean' },
    { property: 'CompanyVendorId', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'CompanyVendor', model: 'CompanyVendor', type: 'association' },
    { property: 'Company', model: 'Company', type: 'association' },
    { property: 'Vendor', model: 'Vendor', type: 'association' },
    {
      property: 'SignedDocumentFiles',
      model: 'SignedDocumentFile',
      type: 'association'
    }
  ];

  static {
    SignedDocument.SignedDocumentProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        SignedDocument.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        SignedDocument.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        SignedDocument.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(SignedDocumentObject: Partial<SignedDocument>) {
    super();

    SignedDocument.SignedDocumentProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = SignedDocumentObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  name?: string;
  signingUrl?: string;
  description?: string;
  documentId?: string;
  widgetId?: string;
  widgetUrl?: string;
  widgetJS?: string;
  service?: string;
  fileName?: string;
  documentType?: string;
  signedDate?: Date;
  isArchived?: boolean;
  CompanyVendorId?: number;
  CompanyId?: number;
  VendorId?: number;
  createdAt?: Date;
  updatedAt?: Date;

  CompanyVendor?: CompanyVendor;
  Company?: Company;
  Vendor?: Vendor;
  SignedDocumentFiles?: SignedDocumentFile[];
}
